module.exports = __webpack_public_path__ + "img/insta_profile.0cb62e3f.png";